module.exports = __webpack_public_path__ + "img/img2.ef56bff1.jpg";